import { apiWithAuth } from "../authApi";

export const getPrice = async (): Promise<number | undefined> => {
  try {
    const response = await apiWithAuth.get("/price");

    const answer = response.data.tokenToUSDT as number;

    return answer;
  } catch (error) {
    return undefined;
  }
};
